import { SET_MANAGGE_DATA_REDUCER } from "../types/manageDataTypes";

export const setManageDataReducer = (payload) => {
  return (dispatch) => {
    dispatch({
      type: SET_MANAGGE_DATA_REDUCER,
      payload: payload,
    });
  };
};
